export const generateTicks = ({
    min,
    max,
    targetTicks = null,
    step = null,
    expand = false
}) => {

    if(min == null || max == null || min === max) return null;

    const normalizeFloat = (value, precision = 12) =>
        parseFloat(value.toFixed(precision));

    let start = Math.min(min, max);
    let end = Math.max(min, max);

    const ticks = [];

    // #region calculating target ticks
    if(typeof targetTicks === "number" && targetTicks > 1)
    {
        const range = end - start;
        const rawStep = range / (targetTicks - 1);

        const magnitude = Math.pow(10, Math.floor(Math.log10(rawStep)));
        const residual = rawStep / magnitude;

        let niceMultiplier;

        if(residual <= 1) niceMultiplier = 1;
        else if(residual <= 2) niceMultiplier = 2;
        else if(residual <= 5) niceMultiplier = 5;
        else niceMultiplier = 10;

        const niceStep = niceMultiplier * magnitude;

        if(expand)
        {
            start = normalizeFloat(Math.floor(start / niceStep) * niceStep);
            end = normalizeFloat(Math.ceil(end / niceStep) * niceStep);
        }

        let first = normalizeFloat(Math.ceil(start / niceStep) * niceStep);

        if(first !== start) ticks.push(normalizeFloat(start));
        

        let v = first;
        while(v < end)
        {
            ticks.push(normalizeFloat(v));
            v = normalizeFloat(v + niceStep);
        }

        if(ticks[ticks.length-1] !== end) ticks.push(normalizeFloat(end));

        return ticks;
    }
    // #endregion

    // #region calculating steps
    if(typeof step === "number" && step > 0)
    {
        const ticks = [];

        if(expand)
        {
            start = normalizeFloat(Math.floor(start / step) * step);
            end = normalizeFloat(Math.ceil(end / step) * step);
        }


        ticks.push(start);
        let firstStep = normalizeFloat(Math.ceil(start / step) * step);

        let v = firstStep;

        while (v < end)
        {
            if(v !== start) ticks.push(normalizeFloat(v));
            v += step;
        }

        if(ticks[ticks.length - 1] !== end) ticks.push(normalizeFloat(end));

        return ticks;
    }
    // #endregion

    return [start, end];
}